import angular from 'angular';
import '../app.constants';
import '../services/organization';
import '../services/external-service';
import './modals/external-services-settings';
import '../services/notifications';

const module = angular.module('whyline.controllers.external-services', [
    'whyline.constants',
    'whyline.services.organization',
    'whyline.services.external-service',
    'whyline.modals.external-services-settings',
    'whyline.services.notifications',
]);

const ExternalServicesController = (
    $scope,
    $timeout,
    OrganizationService,
    ExternalServiceService,
    $uibModal,
    $translate,
    NotificationService,
) => {
    'ngInject';

    $scope.genders = [
        {
            id: 'female',
            value: 'female',
        },
        {
            id: 'male',
            value: 'male',
        },
        {
            id: 'non-binary',
            value: 'non-binary',
        },
        {
            id: 'none',
            value: '',
        },
    ];
    $scope.origins = [
        {
            id: 2,
            value: 'agenda',
        },
        // {
        //     id: 1,
        //     value: 'totem',
        // },
    ];

    $scope.clientIdentificationInfo = {
        idNumber: '',
        gender: '',
    };

    $scope.commercialOfferInfo = {
        idOrigin: $scope.origins[0].id,
        idCobis: '',
    };

    $scope.officialOperatorInfo = {
        idCobis: '',
    };

    $scope.selectedOrganization;
    $scope.selectedGender;
    $scope.selectedOrigin = $scope.origins[0];
    $scope.organizations = [];

    OrganizationService.GetAllAsPromiseFromServer()
        .then(organizations => {
            $timeout(() => {
                $scope.organizations = organizations;
            });
        });

    $scope.updateOrganization = organization => {
        $scope.selectedOrganization = organization;
    }

    $scope.updateGender = gender => {
        $scope.selectedGender = gender;
        $scope.clientIdentificationInfo.gender = gender.value;
    }

    $scope.updateOrigin = origin => {
        $scope.selectedOrigin = origin;
        $scope.commercialOfferInfo.idOrigin = origin.id;
    }

    $scope.viewSettings = () => {
        if ($scope.selectedOrganization) {
            $uibModal.open({
                templateUrl: '/templates/components/modals/external-services-settings.html',
                size: 'md',
                controller: 'ExternalServicesSettingsModalController',
                controllerAs: 'modal',
                resolve: {
                    organization: () => $scope.selectedOrganization,
                }
            });
        }
    }

    $scope.queryClientIdentification = () => {
      if (!validate()) return;

        $scope.clientIdentificationResponse = null;

        ExternalServiceService
            .Identify(
                $scope.clientIdentificationInfo.idNumber,
                $scope.clientIdentificationInfo.gender,
            )
            .then(response => {
                $scope.clientIdentificationResponse = response;
            })
            .catch(error => {
                $scope.clientIdentificationResponse = error;
            });
    }

    $scope.queryCommercialOfferMessage = () => {
        $scope.commercialOfferResponse = null;

        ExternalServiceService
            .CommercialOfferMessage(
                $scope.commercialOfferInfo.idCobis,
                $scope.commercialOfferInfo.idOrigin,
            )
            .then(response => {
                $scope.commercialOfferResponse = response;
            })
            .catch(error => {
                $scope.commercialOfferResponse = error;
            });
    }


    $scope.queryOfficialOperatorMessage = () => {
        $scope.officialOperatorResponse = null;

        ExternalServiceService
            .OfficialOperator(
                $scope.officialOperatorInfo.idCobis,
            )
            .then(response => {
                $scope.officialOperatorResponse = response;
            })
            .catch(error => {
                $scope.officialOperatorResponse = error;
            });
    }

    const validate = () => {
      if (!$scope.selectedGender) {
        NotificationService.Warning($translate.instant('gender_required'));
        return false;
      }
      return true;
    };
};

module.exports = module.controller('ExternalServicesController', ExternalServicesController);